module.exports = __webpack_public_path__ + "img/kefu.32b67d63.png";